import { useState, useEffect, useCallback } from 'react';
import {createContext, useContext} from 'react'
import { toast } from 'react-toastify';
import { api } from '../../../services/api'

export const IndividualMarketPlaceContext = createContext();

export function IndividualMarketPlaceProvider({ children }){
    const [storesBusinessDatas, setStoresBusinessDatas] = useState({})
    const [isLoading, setIsLoading] = useState(true)

    const [selectedCountry, setSelectedCountry] = useState(0)

    const [datasSelectedCountry, setDatasSelectedCountry] = useState({})
    const [datasSelectedState, setDatasSelectedState] = useState(null)

    const [searchResults, setSearchResults] = useState({ business: [] })


    const handleSearchStore = useCallback( async (searchTerm) =>{

      setIsLoading(true)
      
      await api.get(`/getAllBusinessMarketPlace/${window.location.pathname.split('/')[2]}/?searchTerm=${searchTerm}`).then(response => {
        setSearchResults(response.data)
        if(response.data.business.length <= 0){
          toast.warning('Nenhuma loja encontrada')
        }
      })

      setIsLoading(false)

    }, [])

    const handleSelectState = useCallback(async (idState) => {
      setIsLoading(true)
     
      await api.get(`/getAllBusinessMarketPlace/${window.location.pathname.split('/')[2]}/?idState=${idState}`).then(response => {
          setDatasSelectedState(response.data)
        if(response.data.business.length <= 0){
          toast.warning('Nenhuma loja encontrada')
        }
      })

      setIsLoading(false)
    }, [])

   
    useEffect(() =>{
        async function FetchData(){
            try{
                await api.get('/getStatesMarketPlace/' + window.location.pathname.split('/')[2]).then(response => {
                  setStoresBusinessDatas(response.data)
                })
                setIsLoading(false)
            }catch{
                setIsLoading(false)
            }
        }
       FetchData()
    }, [])
   


    useEffect(() => {
      if(storesBusinessDatas.idBusiness !== undefined){
        setDatasSelectedCountry(storesBusinessDatas.countries[selectedCountry])
      }
    }, [storesBusinessDatas, selectedCountry])
   

   
  return(
      <IndividualMarketPlaceContext.Provider  
        value={
          { 
            isLoading,
            selectedCountry,
            storesBusinessDatas,
            datasSelectedCountry,
            datasSelectedState,
            setStoresBusinessDatas,
            setSelectedCountry,
            handleSearchStore,
            setSearchResults,
            handleSelectState,
            setDatasSelectedState,
            searchResults
          }
        }
      >
         { children }
      </IndividualMarketPlaceContext.Provider>
   )
}


export function useIndividualMarketPlace() {
   const context = useContext(IndividualMarketPlaceContext)

   if(!context) {
    throw new Error('useIndividual must be used within an Provider');
  } 

   return context
}